/**
 * Central default logo configuration.
 * To change the R-Link default logo, simply replace the imported file
 * or update the import path below. Every component that uses the
 * default logo pulls from here.
 */
import rlinkDefaultLogo from '../images/R-Link-Studio-Logo-white.png';

export const DEFAULT_LOGO = rlinkDefaultLogo;
export const DEFAULT_LOGO_ALT = 'R-Link Studio';
